import React from "react";
import { ServiceCard } from "./serviceCard";

export function AfiliadoServices() {
  return (
    <div className="m-8 afiliate-service">
      {/* <h3 className="text-xl font-semibold text-white mb-4">Servicios</h3> */}
      <div className="grid gap-4">
        {/* Render ServiceCard as a JSX component */}
        <ServiceCard
          title="Autogestión"
          description="Descarga la documentación necesaria. Accede a múltiples gestiones y tareas"
          icon={
            <svg
              className="mb-3"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#76a934"
              strokeWidth="2"
            >
              <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"></path>
              <path d="M18 14h-8"></path>
              <path d="M15 18h-5"></path>
              <path d="M10 6h8v4h-8V6Z"></path>
            </svg>
          }
        />
        <ServiceCard
          title="Centros de Formación"
          description="Fórmate en nuestros centros de estudios y accede a las mejores oportunidades"
          icon={
            <svg
              className="mb-3"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#76a934"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="10" r="3"></circle>
              <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>
            </svg>
          }
          link="https://unioninformatica.org/campus/"
        />
      </div>
    </div>
  );
}
